import { compact, isEmpty, startCase } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import ReactPaginate from "react-paginate";
import { useForm } from "react-hook-form";
import { FaArrowDownWideShort, FaArrowUpWideShort } from "react-icons/fa6";
import classNames from "classnames";

import { levelMap, toFixedWithoutRounding } from "../../Utils/Constant";
import { apiPut, apiPost, apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import { useContextSelector } from "use-context-selector";
import { role, user_status } from "../../Utils/Constant";
import ChangeStatus from "./ChangeStatus";
import BlockMarketDownline from "./BlockMarketDownline";
import UpdateDialogBox from "./UpdateDialogBox";
import Pagination from "../../components/Pagination";
// import UpdateStatusUser from "../../components/UpdateStatusUser";
// import UpdateDialogBox from "../../components/UpdateDialogBox";

const canEditUser = (currentUser, targetUser) => {
  // Check if the currentUser has a role exactly 1 higher than the targetUser
  if (currentUser === targetUser + 1) {
    return true;
  }
  return false;
};

const UserList = (props) => {
  const userCont = useContextSelector(AuthContext, (ctx) => ctx.user);
  const location = useLocation();
  const user_params = compact(location.pathname.split("/"));

  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  const [changeReference, setChangeReference] = useState(false);
  const [changeAwcLimit, setCreditAwcLimit] = useState(false);
  const [getUpdateId, setUpdateId] = useState("");
  const [getCreditReference, setCreditReference] = useState("");

  const [exposure, setExposure] = useState(false);
  const [exposureData, setExposureData] = useState("");

  const [changeStatus, setChangeStatus] = useState(false);
  const [userData, setUserData] = useState({});
  const [getActiveClass, setActiveClass] = useState("");
  const [currentStatus] = useState("downline");

  const [BlockMarket, setBlockMarket] = useState(false);
  const [selectedName, setSelectedName] = useState("");
  const [getMarketBlockUserId, setMarketBlockUserId] = useState("");
  const [getSportData, setSportData] = useState({});
  const [blockMatchStatus, setMatchBlockStatus] = useState(false);
  const [getMatchStatus, setMatchStatus] = useState("");
  const [sportsListingUpdate, setSportsListingUpdate] = useState({});
  const [sportsListingUpdateId, setSportsListingUpdateId] = useState("");

  const [isLoader, setLoader] = useState(false);

  useEffect(() => {
    setCurrentItems(props?.results?.data || []);
    setPageCount(Math.ceil(props?.results?.totalPages) || 0);
  }, [props]);

  const setChangeReferenceToggle = () => setChangeReference((v) => !v);
  const setChangeAwcLimitToggle = () => setCreditAwcLimit((v) => !v);
  const setChangeBlockMarketToggle = () => setBlockMarket((v) => !v);
  const setMatchBlockStatusToggle = () => setMatchBlockStatus((v) => !v);

  const setChangeStatusToggle = (item) => {
    if (item) {
      setUserData(item);
      setActiveClass(item.status);
    }
    setChangeStatus((v) => !v);
  };

  const setDataForEditReference = (id, creditReference) => {
    setUpdateId(id);
    setCreditReference(creditReference);
    setChangeReferenceToggle();
  };

  const setDataForEditAwcLimit = (id, awcLimit) => {
    setUpdateId(id);
    setCreditAwcLimit(awcLimit);
    setChangeAwcLimitToggle();
  };

  const setExposureToggle = async (type, id) => {
    try {
      const { status, data } = await apiGet(
        `${apiPath.getExpouserData}?userType=${type}&userId=${id}`,
      );
      if (status === 200) {
        setExposureData(data.results.data);
        setExposure(true);
      }
    } catch (err) {}
  };

  const mySportData = async () => {
    const { status, data } = await apiGet(
      `${apiPath.sportList}?userId=${getMarketBlockUserId}`,
    );
    if (status === 200 && data.success) setSportData(data.results);
  };

  const setChangeBlockMarket = async (item) => {
    if (!item) return;
    setMarketBlockUserId(item._id);
    setSelectedName(item?.username);
    const { status, data } = await apiGet(
      `${apiPath.sportList}?userId=${item._id}`,
    );
    if (status === 200 && data.success) {
      setSportData(data.results);
      setChangeBlockMarketToggle();
    }
  };

  const resetMatchBlock = () => {
    setMatchBlockStatusToggle();
    setLoader(false);
    setSportsListingUpdateId("");
    setSportsListingUpdate({});
  };

  const updateMatchStatusSports = async () => {
    try {
      const { status, data } = await apiPut(
        `${apiPath.updateSportsListingStatus}/${sportsListingUpdateId}`,
        sportsListingUpdate,
      );
      if (status === 200 && data.success) {
        mySportData();
        toast.success(data.message);
        resetMatchBlock();
      } else {
        toast.error(data.message);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    reset: reset1,
  } = useForm();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    reset: reset2,
  } = useForm();

  const firstUserType = currentItems?.[0]?.userType;
  const showAwcLimitCol =
    (props?.data === "owner" || props?.data === "sub_owner") &&
    firstUserType === "super_admin";
  const showExposureLimitCol =
    user_params[1] === "agent" || props.data === "agent";
  const canManageAll =
    props?.data === "super_admin" ||
    props?.data === "sub_owner" ||
    props?.data === "owner";

  const totals = currentItems.reduce(
    (acc, u) => {
      const balance =
        u?.userType === "user"
          ? toFixedWithoutRounding(u?.totalCoins1 || 0, 2)
          : toFixedWithoutRounding(u?.totalCoins || 0, 2);
      const newTotalUser =
        u?.totalCoins1 + Math.abs(u?.exposure) <= 0
          ? 0
          : u?.totalCoins1 + Math.abs(u?.exposure);
      const availBal =
        u?.userType === "user"
          ? newTotalUser - u?.exposure
          : u?.totalCoins - Math.abs(u?.exposure);

      acc.balance += Number(balance) || 0;
      acc.pBalance += Number(u.pBalance) || 0;
      acc.exposure += Number(u?.exposure) || 0;
      acc.available += Number(u?.totalCoins1) || 0;
      acc.totalBalance +=
        u?.userType == "user" ? Number(u?.totalCoins) : Number(u?.totalBalance);
      acc.refPL += u.creditReferencePl;
      // : u.creditReference > 0
      //   ? u.creditReference - u?.totalCoins
      //   : 0;
      acc.totalCredRef += u.creditReference || 0;
      return acc;
    },
    {
      balance: 0,
      exposure: 0,
      available: 0,
      refPL: 0,
      totalCredRef: 0,
      pBalance: 0,
      totalBalance: 0,
    },
  );
  return (
    <>
      <div className="table-responsive data-table">
        <div id="widthAll" className="width-all">
          <table
            id="resultTable"
            className="table01 margin-table sortable"
            style={{ display: "table" }}
          >
            <tbody>
              <tr>
                <th
                  id="accountTh"
                  width="10%"
                  data-order={
                    props.sortBy === "account" ? props.orderBy : "asc"
                  }
                  data-name="userName"
                  className="align-L sort_asc"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.handleSort("account")}
                >
                  Account
                </th>

                <th id="creditRefTh" width="10%" className="align-R">
                  Credit Reference
                </th>

                <th
                  id="balanceTh"
                  width="10%"
                  data-order={
                    props.sortBy === "balance" ? props.orderBy : "asc"
                  }
                  data-name="balance"
                  className="sort_asc"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.handleSort("balance")}
                >
                  Balance
                </th>

                {/* {showAwcLimitCol && (
                  <th id="awcLimitTh" width="10%">
                    Awc Limit
                  </th>
                )} */}

                <th
                  id="exposureTh"
                  width="10%"
                  data-order={
                    props.sortBy === "exposure" ? props.orderBy : "asc"
                  }
                  data-name="exposure"
                  className="sort_asc"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.handleSort("exposure")}
                >
                  Exposure
                </th>

                <th
                  id="availableBalanceTh"
                  width="10%"
                  data-order={
                    props.sortBy === "availableBalance" ? props.orderBy : "asc"
                  }
                  data-name="availableBalance"
                  className="sort_asc"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.handleSort("availableBalance")}
                >
                  Available Balance
                </th>

                <th id="creditPLTh" width="10%">
                  Total Balance
                </th>

                {firstUserType !== "user" && (
                  <th id="creditPLTh" width="10%">
                    Player Balance
                  </th>
                )}

                {/* {showExposureLimitCol && (
                  <th id="exposureLimitTh" width="10%">
                    Exposure Limit
                  </th>
                )} */}

                <th
                  id="refPLTh"
                  width="10%"
                  data-name="refPL"
                  className="sort_asc"
                >
                  Reference
                </th>

                <th
                  id="statusTh"
                  width="7%"
                  data-name="userStatus"
                  className="sort_asc"
                >
                  Status
                </th>

                <th id="actionTh" width="15%">
                  Action
                </th>
              </tr>

              {currentItems?.map((u, index) => {
                const balance =
                  u?.userType === "user"
                    ? toFixedWithoutRounding(
                        (u?.totalCoins1 || 0) + Math.abs(u?.exposure || 0),
                        2,
                      )
                    : toFixedWithoutRounding(u?.totalCoins || 0, 2);

                const newTotalUser = u?.totalCoins1 <= 0 ? 0 : u?.totalCoins1;

                const availBal =
                  u?.userType === "user"
                    ? newTotalUser - u?.exposure
                    : u?.totalCoins - Math.abs(u?.exposure);

                const refPL =
                  u.creditReference > 0 ? u.creditReference - u?.totalCoins : 0;
                const refPLPositive = refPL >= 0;
                const refColor =
                  user_params[1] !== "agent"
                    ? refPLPositive
                      ? "red"
                      : "green"
                    : refPLPositive
                      ? "green"
                      : "red";

                const canEditThis =
                  // canManageAll ||
                  canEditUser(role[props?.data], role[u?.userType]);
                // userCont?.userType === "agent";

                return (
                  <tr
                    key={u?._id || index}
                    style={{ display: "table-row", color: "initial" }}
                    id={u?._id}
                  >
                    <td
                      style={{ display: "flex" }}
                      id={`accountCol${index}`}
                      className="align-L"
                    >
                      <span
                        className={`Bdlevel ${levelMap[u?.userType]}`}
                      ></span>
                      {u?.userType === "user" ? (
                        <>{u?.username || null}</>
                      ) : (
                        <Link
                          to={props.handleDrillDown(u)}
                          className="text-primary"
                          style={{ textDecoration: "underline" }}
                        >
                          {u?.username || null}
                        </Link>
                      )}
                    </td>

                    <td
                      className="credit-amount-member"
                      id={`creditRef${index}`}
                    >
                      <span>
                        {toFixedWithoutRounding(u?.creditReference) || null}
                      </span>{" "}
                    </td>

                    <td id={`balance${index}`}>
                      {Math.sign(
                        u?.userType === "user" ? newTotalUser : u?.totalCoins,
                      ) === -1 ? (
                        <span className="red">
                          {toFixedWithoutRounding(
                            u?.userType === "user"
                              ? newTotalUser
                              : u?.totalCoins,
                          )}
                        </span>
                      ) : (
                        toFixedWithoutRounding(
                          u?.userType === "user" ? newTotalUser : u?.totalCoins,
                        )
                      )}
                    </td>

                    {/* {showAwcLimitCol && (
                      <td id={`awcLimit${index}`}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setDataForEditAwcLimit(u._id, u?.awcLimit);
                          }}
                        >
                          {u?.usedAwcLimit >= 0 || !u?.usedAwcLimit
                            ? toFixedWithoutRounding(
                                Math.abs(u?.awcLimit) -
                                  Math.abs(u?.usedAwcLimit),
                              )
                            : toFixedWithoutRounding(u?.awcLimit)}
                          <i className="fas fa-pen ps-1"></i>
                        </a>
                      </td>
                    )} */}

                    <td id={`currentExposure${index}`}>
                      {/* <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setExposureToggle(u?.userType, u?._id);
                        }}
                      > */}
                      <span
                        style={{ color: "#d0021b" }}
                        className="status-suspend1"
                      >
                        ({toFixedWithoutRounding(u?.exposure) || "0.00"})
                      </span>
                      {/* </a> */}
                    </td>

                    <td id={`available${index}`}>
                      {/* {Math.sign(u?.totalCoins1) === -1 ? (
                        <span className="red">
                          {toFixedWithoutRounding(u?.totalCoins1)}
                        </span>
                      ) : (
                        toFixedWithoutRounding(u?.totalCoins1)
                      )} */}
                      {toFixedWithoutRounding(u?.totalCoins1)}
                    </td>
                    <td id={`balance${index}`}>
                      {u?.userType == "user"
                        ? toFixedWithoutRounding(u?.totalCoins)
                        : toFixedWithoutRounding(u?.totalBalance)}
                    </td>
                    {/* <td id={`balance${index}`}>
                      {Math.sign(
                        u?.userType === "user" ? newTotalUser : u?.totalCoins,
                      ) === -1 ? (
                        <span className="red">
                          {toFixedWithoutRounding(
                            u?.userType === "user"
                              ? newTotalUser
                              : u?.totalCoins,
                          )}
                        </span>
                      ) : (
                        toFixedWithoutRounding(
                          u?.userType === "user" ? newTotalUser : u?.totalCoins,
                        )
                      )}
                    </td> */}

                    {firstUserType !== "user" && (
                      <td id={`creditPL${index}`}>
                        {toFixedWithoutRounding(u?.pBalance) || "0.00"}
                      </td>
                    )}

                    <td id={`refPL${index}`}>
                      <span
                        className={
                          u?.creditReferencePl == 0
                            ? ""
                            : u?.creditReferencePl > 0
                              ? "red"
                              : "green"
                        }
                      >
                        {`(${toFixedWithoutRounding(Math.abs(u?.creditReferencePl))})`}
                      </span>
                    </td>
                    {/* // ) : (
                    //   <td id={`refPL${index}`}>
                    //     {u.creditReference > 0 ? (
                    //       <span className={refColor}>
                    //         ({toFixedWithoutRounding(refPL)})
                    //       </span>
                    //     ) : (
                    //       <span>0.00</span>
                    //     )}
                    //   </td>
                    // )} */}

                    <td
                      id={`statusCol${index}`}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <span
                        className={classNames({
                          "status-active": u?.status === "active",
                          "status-suspend": u?.status === "suspend",
                          "status-locked": u?.status === "locked",
                        })}
                        id={`status${index}`}
                      >
                        {startCase(u?.status) || ""}
                      </span>
                    </td>
                    <td id={`actionCol${index}`}>
                      <ul className="action">
                        {canEditThis && (
                          <li>
                            <a
                              title="Change Status"
                              className="status"
                              id={`change${index}`}
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setChangeStatusToggle(u);
                              }}
                            >
                              Change status
                            </a>
                          </li>
                        )}

                        {u?.userType == "user" && (
                          <li>
                            <Link
                              title="Profit & Loss"
                              className="p_l"
                              id={`p_l${index}`}
                              to={`/my-account/profit-loss/${u?._id}/${u?.userType}`}
                            >
                              Betting Profit Loss
                            </Link>
                          </li>
                        )}

                        {u?.userType == "user" && (
                          <li>
                            <Link
                              title="Betting History"
                              className="betting_history"
                              id={`betting_history${index}`}
                              to={`/my-account/betting-history/${u?._id}/${u?.userType}`}
                            >
                              Betting History
                            </Link>
                          </li>
                        )}

                        <li>
                          <Link
                            title="Account Summary"
                            className="profile"
                            id={`profile${index}`}
                            to={`/my-account/account-summary/${u?._id}/${u?.userType}`}
                          >
                            Profile
                          </Link>
                        </li>

                        {/* {[
                          "agent",
                          "super_admin",
                          "sub_owner",
                          "owner",
                        ].includes(userCont?.userType) && ( */}
                          <li>
                            <a
                              className="lock"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setChangeBlockMarket(u);
                              }}
                            >
                              Block
                            </a>
                          </li>
                        {/* )} */}
                      </ul>
                    </td>
                  </tr>
                );
              })}

              {isEmpty(currentItems) && (
                <tr>
                  <td colSpan={5}>No records found</td>
                </tr>
              )}
              {!isEmpty(currentItems) && (
                <tr style={{ fontWeight: 700 }}>
                  <td className="align-L">Total</td>
                  <td>
                    {toFixedWithoutRounding(props?.balance?.totalCreditReference)}
                  </td>
                  <td>
                    {toFixedWithoutRounding(props?.balance?.playerBalance)}
                  </td>
                  <td>
                    <span className="red">
                      (
                      {toFixedWithoutRounding(
                        Math.abs(props?.balance?.playerExposure),
                      )}
                      )
                    </span>
                  </td>
                  <td>
                    {toFixedWithoutRounding(
                      props?.balance?.totalAvailableBalance,
                    )}
                  </td>
                  <td>
                    {toFixedWithoutRounding(props?.balance?.totalBalance)}
                  </td>
                  {firstUserType !== "user" && (
                    <td>
                      {toFixedWithoutRounding(props?.balance?.playerBalance)}
                    </td>
                  )}
                  <td>
                    <span
                      className={
                        props?.balance?.creditReferences == 0
                          ? ""
                          : props?.balance?.creditReferences > 0
                            ? "red"
                            : "green"
                      }
                    >
                      {props?.balance?.creditReferences >= 0
                        ? `${toFixedWithoutRounding(props?.balance?.creditReferences)}`
                        : `(${toFixedWithoutRounding(Math.abs(props?.balance?.creditReferences))})`}
                    </span>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              )}
              {/* {!isEmpty(currentItems) && (
                <tr style={{ fontWeight: 700 }}>
                  <td className="align-L">Total</td>
                  <td>{toFixedWithoutRounding(totals.totalCredRef)}</td>
                  <td>{toFixedWithoutRounding(totals.balance)}</td>
                  <td>
                    <span className="red">
                      ({toFixedWithoutRounding(Math.abs(totals.exposure))})
                    </span>
                  </td>
                  <td>{toFixedWithoutRounding(totals.available)}</td>
                  <td>{toFixedWithoutRounding(totals.totalBalance)}</td>
                  {firstUserType !== "user" && (
                    <td>{toFixedWithoutRounding(totals.pBalance)}</td>
                  )}
                  <td>
                    <span className={totals.refPL >= 0 ? "" : "red"}>
                      {totals.refPL >= 0
                        ? `${toFixedWithoutRounding(totals.refPL)}`
                        : `(${toFixedWithoutRounding(totals.refPL)})`}
                    </span>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              )} */}
            </tbody>
          </table>
          <div className="bottom-pagination">
            {props?.results?.data?.length > 0 &&
              props?.results?.totalDocs > 0 && (
                <Pagination
                  pagination={props?.results}
                  onPageChange={props?.handlePageChange}
                />
              )}
          </div>
        </div>
      </div>

      <ChangeStatus
        changeStatus={changeStatus}
        setChangeStatusToggle={setChangeStatusToggle}
        userData={userData}
        getActiveClass={getActiveClass}
        setActiveClass={setActiveClass}
        getUsers={props.getUsers}
        currentStatus={currentStatus}
      />
      <BlockMarketDownline
        isOpen={BlockMarket}
        onClose={setChangeBlockMarketToggle}
        userName={selectedName}
        getSportData={getSportData}
        getMarketBlockUserId={getMarketBlockUserId}
        setSportsListingUpdate={setSportsListingUpdate}
        setMatchStatus={setMatchStatus}
        setMatchBlockStatusToggle={setMatchBlockStatusToggle}
        setSportsListingUpdateId={setSportsListingUpdateId}
      />

      <UpdateDialogBox
        open={blockMatchStatus}
        onClose={setMatchBlockStatusToggle}
        onSubmit={updateMatchStatusSports}
        isLoader={isLoader}
        headerTitle={"Block/Un-Block Match"}
        title={`You Want to ${getMatchStatus} This Match?`}
      />
    </>
  );
};

export default UserList;
